import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import React, { useState, useEffect } from 'react';

const Example = ({ data, showModal, closeModal, depositType, tableName, addNewRow }) => {
  const [editField, setEditField] = useState({})
  const [show, setShow] = useState(showModal);
  const handleClose = () => closeModal(false);
  const handleShow = () => setShow(true);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setEditField(data)
  }, [])

  const submitData = async () => {
    setLoading(true)
    console.log("sending req")

    const res = await fetch(`${process.env.REACT_APP_APIURL}/rates/bajaj/`, {
      method: addNewRow ? "POST" : "PUT",
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify(editField)
    })
    setLoading(false)
    if (res.ok) {
      closeModal(false)
    } else {
      alert("unable to save please try again")
    }

  }

  const deleteRow = async () => {
    setLoading(true)
    // {"id":1,"tenure":"15","cumulative":"6.40","monthly":"6.22","quarterly":"6.25","halfyearly":"6.40","annual":"6.40"}
    const res = await fetch(`${process.env.REACT_APP_APIURL}/rates/bajaj/?id=${editField.id}`, {
      method: "DELETE",
    })

    if (res.ok) {
      console.log("deleted")
      closeModal(false)
    } else {
      alert("Please try again")
    }
    setLoading(false)
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{addNewRow ? "adding new row " : "Editing row "}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex flex-row justify-content-between'>
            <div class="form-floating  mb-2 ">
              <input style={{ cursor: "not-allowed" }} type="text" onChange={(e) => {
                setEditField((prev) => ({ ...prev, deposit_type: e.target.value }))
              }} disabled value={editField.deposit_type} class="form-control" id="depositType" />
              <label for="depositType ">deposit Type</label>
            </div>
            <div class="form-floating mb-2">
              <input style={{ cursor: "not-allowed" }} type="text" onChange={(e) => {
                setEditField((prev) => ({ ...prev, tenor: e.target.value }))
              }} disabled value={editField.table_type} class="form-control" id="table_type" />
              <label for="table_type">table type</label>
            </div>
          </div>


          <div class="form-floating mb-2">
            <input type="text" onChange={(e) => {
              setEditField((prev) => ({ ...prev, tenor: e.target.value }))
            }} value={editField.tenor} class="form-control" id="tenure" />
            <label for="tenure ">Tenor</label>
          </div>

          <div class="form-floating mb-2">
            <input onChange={(e) => {
              setEditField((prev) => ({ ...prev, cumulative: e.target.value }))
            }} type="text" value={editField.cumulative} class="form-control" id="cumulative" />
            <label for="cumulative ">cumulative</label>
          </div>
          <div class="form-floating mb-2">
            <input type="text" onChange={(e) => {
              setEditField((prev) => ({ ...prev, monthly: e.target.value }))
            }} value={editField.monthly} class="form-control" id="monthly" />
            <label for="monthly ">monthly</label>
          </div>
          <div class="form-floating mb-2">
            <input type="text" onChange={(e) => {
              setEditField((prev) => ({ ...prev, quarterly: e.target.value }))
            }} value={editField.quarterly} class="form-control" id="quarterly" />
            <label for="quarterly ">quarterly</label>
          </div>
          <div class="form-floating mb-2">
            <input type="text" onChange={(e) => {
              setEditField((prev) => ({ ...prev, halfyearly: e.target.value }))
            }} value={editField.halfyearly} class="form-control" id="halfyearly" />
            <label for="halfyearly ">halfyearly</label>
          </div>
          <div class="form-floating mb-2">
            <input type="text" onChange={(e) => {
              setEditField((prev) => ({ ...prev, annual: e.target.value }))
            }} value={editField.annual} class="form-control" id="annual" />
            <label for="annual ">annual</label>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button disabled={loading} variant={loading ? "success" : "primary"} onClick={submitData}>
            {loading ? "processing request..." : "save"}
          </Button>
          {
            !addNewRow && <Button disabled={loading} variant="danger" onClick={deleteRow}>
              {loading ? "processing request..." : "delete"}
            </Button>
          }

        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Example